
    <header class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
        <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6" >NAFLIGHT Firm
          <ul *ngIf="auth.user$ | async as user">
            <li>{{ user.email }}</li>
          </ul>
          <!-- <i class="nav-link px-3" *ngIf="auth.isAuthenticated()">Welcomes John</i> -->
        </a>
        <div class="navbar-nav">
          <div class="nav-item text-nowrap">
            <ng-container *ngIf="auth.isAuthenticated$ | async; else loggedOut">
              <button class="btn btn-primary p-1 m-2" (click)="signOut() " routerLink='/home'>
                Log out
              </button>
            </ng-container>
        
            <ng-template #loggedOut>
              <button class="btn btn-primary p-2 m-2" (click)="loginUser()">Log in</button>
            </ng-template>
            <!-- <a class="nav-link px-3 " (click)="signOut()" *ngIf="auth.isAuthenticated$ | async; else loggedOut" routerLink='/home'>Sign out</a>
            <a class="nav-link px-3"  *ngIf="!auth.isAuthenticated$" routerLink='/login'>Sign in</a> -->
          </div>
        </div>
    </header>
    